var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.96,
    height: 22.967,
    viewBox: "0 0 22.96 22.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.522,0a.721.721,0,0,0-.5.211l-2.53,2.532a.715.715,0,0,0-.211.211L10.847,5.388a.744.744,0,0,0-.184.184L8.217,8.018l-.005,0a.754.754,0,0,0-.19.193L5.584,10.651a.7.7,0,0,0-.209.209L2.938,13.295a.805.805,0,0,0-.184.187L.21,16.025a.718.718,0,0,0,0,1.014l5.718,5.718a.716.716,0,0,0,1.014-.005L22.752,6.939a.72.72,0,0,0,0-1.011L17.034.21,16.985.161A.722.722,0,0,0,16.522,0Zm.008,1.735,4.7,4.7-14.8,14.8-4.7-4.7,1.621-1.621L5.812,17.37a.719.719,0,0,0,1.017-1.017L4.369,13.9l1.619-1.619,1.337,1.337A.72.72,0,1,0,8.344,12.6L7,11.261,8.623,9.64,11.08,12.1A.72.72,0,0,0,12.1,11.082L9.64,8.626,11.259,7,12.6,8.346a.718.718,0,0,0,1.055-.973l-.043-.043L12.273,5.99l1.621-1.621,2.459,2.459a.718.718,0,0,0,1.09-.935,1.04,1.04,0,0,0-.076-.079L14.911,3.352Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.806b707b9b99680dfc822cffa895ab21.svg";
export { ForwardRef as ReactComponent };